var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('e-horizon-index-tabs'),_vm._v(" "),(_vm.showBanner)?_c('promo-bar',{attrs:{"promoBanner":_vm.promoBanner},on:{"reloadBanner":function($event){return _vm.showPromoBanner()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }